import React from "react";
const defaultTranslationFunction = (input) => input;
const TranslationContext = React.createContext(defaultTranslationFunction);
export default TranslationContext;
